<script setup lang="ts">

import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppMultiSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useDisciplineModalMerge } from '../../model/discipline-modal-merge.hook'

defineOptions({
  name: 'ModalDisciplineMerge',
})

const {
  refIsOpen,
  refTitle,
  refKidName,
  refOptions,
  refSelectedIds,
  closeModal,
  confirmSelection,
} = useDisciplineModalMerge()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :title="refTitle"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <div class="modal-discipline-merge">
      <div class="modal-discipline-merge__kid">
        <AppText name="body1">
          Main discipline:
        </AppText>
        <AppText name="body1-medium">
          {{ refKidName }}
        </AppText>
      </div>
      <AppMultiSelect
        v-model="refSelectedIds"
        label="Select kids to merge:"
        placeholder="Select here"
        :options="refOptions"
      />
      <div class="modal-discipline-merge__info">
        <AppIcon
          :icon="faInfoCircle"
          size="small"
          color="blue-600"
        />
        <AppText
          name="body1"
          color="slate-900"
        >
          Merging is only allowed for disciplines without balances and subscriptions.
        </AppText>
      </div>
    </div>
    <template #controls>
      <div class="modal-discipline-merge__controls">
        <BtnPrimary
          text="Confirm"
          color="emerald"
          :disabled="!refSelectedIds.length"
          @click="confirmSelection"
        />
        <BtnSecondary
          text="Close"
          color="black"
          @click="closeModal"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineMerge.scss" />
